import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// Self-hosted Web-Fonts (Variable) — ersetzt das Google-Fonts-CDN.
// Vite bündelt die woff2 und liefert sie von der eigenen Domain aus
// (kein IP-Transfer an Google, DSGVO/#47). Variable Fonts decken alle
// genutzten Schnitte ab; die font-family-Tokens in index.css listen
// 'Inter Variable' / 'JetBrains Mono Variable' an erster Stelle.
import '@fontsource-variable/inter'
import '@fontsource-variable/jetbrains-mono'
import './index.css'
import App from './App.jsx'
import { useAuthStore } from './stores/authStore'
import { installErrorReporter } from './lib/errorReporter'
import { initSentry } from './lib/sentry'
import { installFetchInterceptor, startHeartbeat } from './lib/apiClient'
import { captureSignupSource } from './lib/analytics'
import { installChunkReload } from './lib/chunkReload'
import ReloadBoundary from './components/ReloadBoundary'

// Sentry zuerst — fängt Stack-Traces + Source-Map-Resolution.
// No-op wenn VITE_SENTRY_DSN nicht gesetzt ist (Dev-Default).
initSentry();
// Plausible-Counter-Reporter parallel — gibt "wie oft" ohne PII;
// Sentry gibt "warum" mit Stack.
installErrorReporter();
// Nach einem Deploy fehlende Dateien: einmal neu laden (vite:preloadError).
installChunkReload();

// Patch window.fetch so 401s from /api/auth/* with reason=
// session_replaced/session_not_registered/session_expired trigger an auto-logout
// (Device-Limit, Task #25). Has to run before initialize() because
// initialize triggers fetches via onAuthStateChange.
installFetchInterceptor();

// Heartbeat for Pro live-calc: a tab that only does client-side
// computation never hits /api/, so the device-limit eviction
// wouldn't otherwise surface until the next real request. The 60 s
// ping closes that gap (visibility-gated, see startHeartbeat).
startHeartbeat();

// Signup-Quelle aus der Einstiegs-URL puffern (utm_source), bevor irgendeine
// Route rendert — fängt sowohl /register-Deeplinks als auch Home-Einstiege.
// Idempotent, reines best-effort.
captureSignupSource();

// Initialize auth on app start
useAuthStore.getState().initialize();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ReloadBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ReloadBoundary>
  </StrictMode>,
)
